import React, { Component } from 'react';
import { connect } from "react-redux";

import { getGuid } from "redux/reducers/exam/selectors";
import { getExamData, getSchedulesData } from "redux/reducers/selectors";
import { getScheduleDataByExamGuid } from "redux/reducers/schedules/selectors";
import { getProctorProvider } from 'redux/reducers/schedules/schedule/selectors';

import { PROCTORING_TYPES } from 'constants/proctoring';

class CloseOctoProctor extends Component {
    state = {}

    componentDidMount() {
        const { onComplete } = this.props;

        if (this.isOctoProctor()) {
            try{
                console.log('Closing OctoProctor session');

                if (window.supervisor) {
                    window.supervisor.stop();
                }
            }
            catch(e){
                console.log("Unable to close OctoProctor session", e);
            }
        }

        onComplete();
    }

    isOctoProctor() {
        const { proctoringProvider } = this.props;

        return proctoringProvider === PROCTORING_TYPES.OCTO_PROCTOR;
    }

    render() {
        return null;
    }
}

const mapStoreToProps = (store) => {
    const examData = getExamData(store);
    const examGuid = getGuid(examData);

    const schedulesData = getSchedulesData(store);
    const scheduleData = getScheduleDataByExamGuid(schedulesData)(examGuid);
    const proctoringProvider = getProctorProvider(scheduleData)


    return { proctoringProvider }
}

CloseOctoProctor = connect(mapStoreToProps)(CloseOctoProctor);

export { CloseOctoProctor };
